import React from 'react';
import { makeStyles } from 'tss-react/mui';
import _get from 'lodash/get';
import styles from "./AcceptedCards.styled.js";
export var AcceptedCards = function AcceptedCards(_ref) {
  var config = _ref.config,
    partnerCards = _ref.partnerCards;
  var useStyles = makeStyles()(styles);
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var acceptedCards = _get(config, 'acceptedCards', []);
  var displayedCards = _get(partnerCards, 'length') ? partnerCards : acceptedCards;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.acceptedCards
  }, displayedCards && displayedCards.map(function (card) {
    return /*#__PURE__*/React.createElement("img", {
      loading: "lazy",
      alt: card.name,
      src: card.logoUrl || card.logo_url,
      width: "32",
      height: "32"
    });
  }));
};